export default __webpack_public_path__ + "media/images/btn-add-dddecb14533d10b905e78c177c5b23e5.png";